import { createReducer, Action, on } from '@ngrx/store';

import { State as CoreState } from '@emm/core/store/core.reducer';
import { AuthActions } from './auth.actions';
import {AuthenticationStatus} from '@emm/core/models/enums';
import {User} from '@emm/core/models/user.model';

export const authFeatureKey = 'auth';

export interface AuthState {
    user: User;
    status: AuthenticationStatus;
}

export interface State extends CoreState {
    [authFeatureKey]: AuthState;
}

export const initialState: AuthState = {
    status: AuthenticationStatus.NotAuthorized,
    user: null
};

const authCreateReducer = createReducer(
    initialState,
    on(AuthActions.authenticateUser, (state) => ({
        ...state,
        status: AuthenticationStatus.Authorizing
    })),
    on(AuthActions.authenticateUserSuccess, (state, { user }) => ({
        ...state,
        user,
        status: AuthenticationStatus.Authorized
    })),
    on(AuthActions.signOut, (state) => ({
        ...state,
        user: null,
        status: AuthenticationStatus.NotAuthorized
    }))
);

export function authReducer(state: AuthState | undefined, action: Action) {
    return authCreateReducer(state, action);
}
